import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50" data-product-shop>
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our curated product categories and discover the best finds organized with Basetao Spreadsheet systems.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 hover:bg-primary-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-square overflow-hidden bg-background-200">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 group-hover:text-primary-600 group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.iconClass} text-xs`}></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 border border-primary-200 hover:border-primary-300 rounded-lg transition-colors whitespace-nowrap"
          >
            View All Categories <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}